// Helpers de formato centralizados para toda la app.
// Reemplaza las funciones `clp()` / `fmt()` dispersas por componente.

const LOCALES = {
  USD: "en-US",
  CLP: "es-CL", COP: "es-CO", MXN: "es-MX", ARS: "es-AR",
  PEN: "es-PE", BRL: "pt-BR", UYU: "es-UY",
};

// Formato monetario consistente. CLP/COP/etc no tienen decimales por convención
// dropshipping LATAM; USD sí.
export function formatCurrency(amount, currency = "CLP", opts = {}) {
  const value = Number(amount || 0);
  const locale = LOCALES[currency] || "es-CL";
  return value.toLocaleString(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: opts.decimals ?? (currency === "USD" ? 2 : 0),
  });
}

// Atajo para CLP (caso más usado hoy en la app).
export function clp(amount) {
  return formatCurrency(amount, "CLP");
}

// Número con separadores, sin símbolo de moneda (para tablas, KPIs porcentuales).
export function formatNumber(amount, decimals = 0) {
  return Number(amount || 0).toLocaleString("es-CL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// Porcentaje formateado.
export function formatPercent(value, decimals = 1) {
  return `${Number(value || 0).toFixed(decimals)}%`;
}
